import { PROFILE_CLASS_NAME, PROFILES_DOMAIN, PROFILES_PATH } from '@gymaholic/packages'
import { createLogger } from 'logger-js'
import loadReduxAction from 'modules/redux/actions/load'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import getPathFromDomainPathReduxUtil from 'modules/redux/utils/get-path-from-domain-map-path'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import { getProfileByNameSelector } from 'modules/profile/redux/selectors'

const LOAD_BY_NAME = 'LOAD_BY_NAME'

const PROFILES_ENDPOINT = {
  LOAD_BY_NAME: '/profiles/name/:name'
}

export default function loadByNameProfileAction (name) {
  const logger = createLogger({
    label: 'loadByNameProfileAction'
  })

  return async (dispatch, getState) => {
    const profile = getProfileByNameSelector(name)(getState())
    const profileId = getIdReduxUtil(profile)
    if (!name) {
      logger.warn('[noop] no name provided')
      return
    }
    try {
      await dispatch(loadReduxAction({
        type: LOAD_BY_NAME,
        payload: {
          endpoint: getEndpointTrainingUtil(interpolateRouteUtil(PROFILES_ENDPOINT.LOAD_BY_NAME,
            { name }
          )),
          domainListPath: PROFILES_PATH.ALL,
          path: profile
            ? getPathReduxUtil(profile)
            : getPathFromDomainPathReduxUtil(PROFILES_DOMAIN, profileId),
          data: profile
            ? null
            : {
                id: profileId,
                className: PROFILE_CLASS_NAME
              }
        }
      }))
    } catch (error) {
      logger.error(`loading profiles with name ${name} failed `, error)
    }
  }
}
